import React from 'react'
import {
  Layout,
  Icon,
  Menu,
  Dropdown,
  Avatar,
  Input,
  List,
  message,
  Spin,
  Tooltip,
  Button,
  Popover,
  Divider
} from 'antd'
import { withRouter, Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import DownloadFtXModal from '../../components/DownloadFtXModal'

import Share from '../../components/FilesShare/share'
import MediaInfo from '../../components/MediaInfo'

import sideThumb from '../../assets/img/icon/sideThumb.png'
import logo from '../../assets/logo/cloudflyer-logo-header-white.png'
import Notify from '../../components/Notifications/NotifyIcon'
import Search from '../../components/Omnibox'
import { is_supported_video_format } from '../../utils'
import CloudFlyerAPI from '../../api/CloudFlyerAPI'
import { play_file } from '../../actions/video-player'
import { ReactComponent as Logo } from '../../assets/svg/user.svg';

import NavigationItems from '../Header/NavigationItems/navigationItems';

import './styles.scss'

class commonHeader extends React.Component {
  constructor() {
    super()

    this.state = {
      siderCollapsed: false,
      showFtXDownload: false,
      searchKeyword: '',
      visibleSearch: false,
      loading: false,
      current: 'mail',
    }
  }

  openFtXModal = () => {
    const { showFtXDownload } = this.state
    if (!showFtXDownload) {
      this.setState({ showFtXDownload: true })
    }
  }

  closeFtXModal = () => this.setState({ showFtXDownload: false })

  onToggle = () => {
    this.setState({
      siderCollapsed: !this.props.siderCollapsed,
    })
    this.props.onToggle()
  }

  on_menu_click = ({ key }) => {
    if (key === 'logout') return this.props.history.replace('/login')
    this.props.history.replace(key)
  }

  toggleSearch = () =>
    this.setState(({ visibleSearch }) => ({
      visibleSearch: !visibleSearch,
    }))

  onSearchOpen = () => {
    this.setState({ visibleSearch: true })
  }

  onSearchClose = () => {
    this.setState({ visibleSearch: false })
  }

  onSearch = e => {
    const value =
      (e.target && e.target.value) || e.target.value === '' ? e.target.value : e
    this.setState({ searchKeyword: value, visibleSearch: true })
  }

  setLoading = loading => {
    this.setState({ loading })
  }

  handleClick = e => {
    console.log('click ', e);
    this.setState({ current: e.key });
  };

  render() {
    const { profile, play_file } = this.props
    const {
      showFtXDownload,
      searchKeyword,
      visibleSearch,
      loading,

    } = this.state

    const {
      email: username = '',
      email = '',
      firstname = '',
      lastname = '',
      userType = 0
    } = profile.user || {}

    const menu = (
      <Menu
        className={'setting-menu'}
        selectedKeys={[]}
        onClick={this.on_menu_click}
      >
        {/* <Menu.Item key={'/profile'}>
          <Icon type="setting" />
          Profile
        </Menu.Item> */}

        {/* <Menu.Item key={'/users'}>
          <Icon type="setting" />
          Account
        </Menu.Item> */}

        <Menu.Item key={'/mboard'}>
          <Icon type="dashboard" />
          Migration Status
        </Menu.Item>
        <Menu.Item key={'/rboard?sync=true'}>
          <Icon type="dashboard" />
          Replication Status
        </Menu.Item>

        <Menu.Item key={'/mfa'}>
          <Icon type="dashboard" />
          Settings
        </Menu.Item>

        <Menu.Divider />
        <Menu.Item key={'logout'}>
          <Icon type="logout" />
          LogOut
        </Menu.Item>

        {/* <Menu.Item key={'/billing'}>
          <Icon type="setting" />
          Billing Details
        </Menu.Item> */}
      </Menu>
    )

    let admin = false;

    let navigationItems = []

    if(userType == 4)
    {
      navigationItems = 
      [
        {label:"Dashboard", link: "/dashboard"},
        {label:"Cloud Providers", link: "/cloudproviders" },
        {label:"Replication", link: "/replication" },
        {label:"Migration", link: "/migration" },
      ]
    }
    else
    {
      navigationItems = 
      [
        {label:"Dashboard", link: "/dashboard"},
        {label:"Cloud Providers", link: "/cloudproviders" },
        {label:"Replication", link: "/replication" }
      ]
    }



    const { current } = this.state;

    // const headerMenu = (
      
    // )

    return (
      <Layout.Header className="header_comp noselect">
        {/* <a className="sideThumb" onClick={this.props.onToggle}>
                    <img src={sideThumb} />
                    </a>
                  

        <Icon
                    type="search"
                    className="search"
                    onClick={this.toggleSearch}
                    /> */}
                  
        {/* <div className="search-input-container">
          <Popover
            arrowPointAtCenter={false}
            content={
              <SearchDropdown
                searchKeyword={searchKeyword}
                onClose={this.onSearchClose}
                play_file={play_file}
                setLoading={this.setLoading}
              />
            }
            trigger="click"
            placement="bottomRight"
            overlayClassName={'search-popover'}
            visible={searchKeyword !== '' && visibleSearch}
            onVisibleChange={visible => {
              if (!visible) this.onSearchClose()
              else this.onSearchOpen()
            }}
          >
            <Input
              className="search-input"
              placeholder="Search ... "
              prefix={
                (searchKeyword === '' || !visibleSearch) && (
                  <Icon type="search" />
                )
              }
              suffix={
                searchKeyword !== '' &&
                visibleSearch && <Icon type={loading ? 'loading' : 'search'} />
              }
              value={searchKeyword}
              onChange={this.onSearch}
            />
          </Popover>
        </div> */}
        <div className="logo-wrapper">
          <a className="logo">
            <img src={logo} />
          </a>
          {/* <div className="vertical-divider"></div> */}
          {/* <h3 className="title">Wasabi Bucket Replication Manager</h3> */}
        </div>
        
        <div className="menu-wrapper">
          <NavigationItems navLinks={navigationItems}></NavigationItems>
        </div>

        <div className="widgets-wrapper">
          <Notify />
          <p className="header-user-name">Hi, {firstname.charAt(0).toUpperCase( )+ firstname.slice(1)}</p>

            {/* <DownloadFtXModal
              visible={showFtXDownload}
              onClose={this.closeFtXModal}
            /> */}
            
            {/* <Icon type="down" /> */}
            <Dropdown overlay={menu} className="user-droppanel">
              <span className={'action'}>
                <Logo className="header-user-icon"/>
                {/* <Avatar style={{ verticalAlign: 'middle' }} alt="">
                  {' '}
                  {first_name.charAt(0).toUpperCase() +
                    ' ' +
                    last_name.charAt(0).toUpperCase()}
                </Avatar> */}
              </span>
            </Dropdown>
        </div>
        
      </Layout.Header>
    )
  }
}

const mapStateToProps = store => store

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      play_file,
    },
    dispatch
  )

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(commonHeader)
)
